import { render } from "./OrderDetail.vue?vue&type=template&id=6304d570&scoped=true"
import script from "./OrderDetail.vue?vue&type=script&lang=js"
export * from "./OrderDetail.vue?vue&type=script&lang=js"

import "./OrderDetail.vue?vue&type=style&index=0&id=6304d570&scoped=true&lang=css"
import "./OrderDetail.vue?vue&type=style&index=1&id=6304d570&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6304d570"]])

export default __exports__